import React from 'react';
import { Button, Typography, CircularProgress } from '@material-ui/core';
import { useStyles, FormContainer } from './styles';
import { useHistory } from 'react-router-dom';
import { ModalResponseAlert } from 'page/Schedule/WeekSchedule/components/ModalResponseAlert';

const FooterButton = ({
  type,
  id,
  loading,
  status,
  error,
  setError = () => {},
  message,
}) => {
  const history = useHistory();
  const classes = useStyles();
  const [openModalSendNotification, setOpenModalSendNotification] =
    React.useState(false);

  React.useEffect(() => {
    if (status === 200 || status === 201 || error)
      setOpenModalSendNotification(true);
  }, [status, error]);

  const handleCloseModal = () => {
    if (error) {
      setOpenModalSendNotification(false);
      setError(false);
    } else {
      history.push(`/cadastros/administradores`);
    }
  };
  const goBack = () => history.goBack();
  return (
    <FormContainer style={{ justifyContent: 'flex-end', marginTop: 48 }}>
      <Button onClick={goBack} className={classes.cancelButton}>
        <Typography className={classes.cancelText}>Cancelar</Typography>
      </Button>
      {id ? (
        <>
          <Button
            disabled={loading}
            type={type}
            className={classes.registerButton}
          >
            {loading ? (
              <CircularProgress size={12} style={{ marginRight: 3 }} />
            ) : (
              <Typography className={classes.registerText}>Salvar</Typography>
            )}
          </Button>
          {status !== 200 || status !== 201 ? (
            <ModalResponseAlert
              messageTitleAlert={
                message ?? 'Administrador editado com sucesso!'
              }
              openSendFinish={openModalSendNotification}
              handleCloseSendFinish={handleCloseModal}
              error={error && status !== 400}
              alert={error && status === 400}
            />
          ) : (
            <ModalResponseAlert
              messageTitleAlert={message ?? 'Profissional já cadastrado!'}
              openSendFinish={openModalSendNotification}
              handleCloseSendFinish={handleCloseModal}
              error={error && status !== 400}
              alert={error && status === 400}
            />
          )}
        </>
      ) : (
        <>
          <Button
            disabled={loading}
            type={type}
            className={classes.registerButton}
          >
            {loading ? (
              <CircularProgress size={12} style={{ marginRight: 3 }} />
            ) : (
              <Typography className={classes.registerText}>
                Cadastrar
              </Typography>
            )}
          </Button>
          {openModalSendNotification && (
            <ModalResponseAlert
              messageTitleAlert={
                message ?? 'Administrador cadastrado com sucesso!'
              }
              openSendFinish={openModalSendNotification}
              handleCloseSendFinish={handleCloseModal}
              error={error && status !== 400}
              alert={error && status === 400}
            />
          )}
        </>
      )}
    </FormContainer>
  );
};

export default FooterButton;
